module.exports = __webpack_public_path__ + "media/di.b6f16381.wav";